import { Controller } from "@hotwired/stimulus"

// Local previews only: private evidence is uploaded with the report form.
export default class extends Controller {
  static targets = ["input", "previews", "summary"]

  connect() {
    this.urls = []
  }

  disconnect() {
    this.releaseUrls()
  }

  preview() {
    this.releaseUrls()
    this.previewsTarget.replaceChildren()
    const files = Array.from(this.inputTarget.files)
    this.summaryTarget.textContent = files.length ? `${files.length} new photo${files.length === 1 ? "" : "s"} selected. Not uploaded yet.` : ""

    for (const [index, file] of files.entries()) {
      const figure = document.createElement("figure")
      figure.className = "min-w-0 overflow-hidden rounded-xl border border-gray-200 bg-gray-50"
      if (["image/jpeg", "image/png", "image/gif", "image/webp"].includes(file.type)) {
        const img = document.createElement("img")
        const url = URL.createObjectURL(file)
        this.urls.push(url)
        img.src = url
        img.alt = `Selected evidence photo ${index + 1}`
        img.className = "aspect-[4/3] w-full object-contain"
        figure.append(img)
      }
      const caption = document.createElement("figcaption")
      caption.className = "break-words px-3 py-2 text-xs text-gray-600"
      caption.textContent = `${file.name} · ${(file.size / 1024 / 1024).toFixed(1)} MB`
      figure.append(caption)
      this.previewsTarget.append(figure)
    }
  }

  releaseUrls() {
    this.urls.forEach(url => URL.revokeObjectURL(url))
    this.urls = []
  }
}
